import React, { memo } from "react";
import type { CoverProps } from "./interfaces";
import styles from "./style.module.scss";
import { CoveringBottomProps } from "./interfaces";
import { CoveringCornerProps } from "./interfaces";

const Cover = ({
  className = "",
  width = 52,
  height,
  auto = false,
  children,
  src,
  alt = "",
  imgClassName = "",
  ...otherProps
}: CoverProps) => {
  const _height: number = height || (width * 3) / 2;
  return (
    <span
      className={`${className} ${styles.bookCover} pr br4 dib vam bc_default bsbb`}
      style={
        auto
          ? { width: "100%", height: "100%" }
          : { width: `${width / 16}rem`, height: `${_height / 16}rem` }
      }
    >
      <div
        className={`pa t0 l0 br2 w100% h100% ${imgClassName}`}
        style={{
          width: width,
          height: _height,
          background: `url(${src}) center/auto 100% no-repeat border-box border-box`,
        }}
        {...otherProps}
      />
      {children}
    </span>
  );
};

export const CoveringCorner = ({
  className = "",
  backgroundColor,
  position,
  children,
}: CoveringCornerProps) => {
  return (
    <span
      className={`${className} ${styles.cornerBadge} pa _${position} df aic jcc t_label_l`}
      style={{ backgroundColor }}
    >
      {children}
    </span>
  );
};
export const CoveringBottom = ({
  backgroundColor,
  color,
  children,
}: CoveringBottomProps) => {
  return (
    <span
      className={`${styles.bottomPart} pa b0 l0 r0 w100% t_label_m ell tac pl8 pr8`}
      style={{ backgroundColor, color }}
    >
      {children}
    </span>
  );
};

export default memo(Cover);
